module.exports = __webpack_public_path__ + "img/hector-meza.5e20a6f5.png";